export * from "./delete-account-confirmation.component";
